import { BottomDrawerModalAnimated } from "@/components/shared/bottom-drawer-modal-animated";
import { Typography } from "@/components/shared/typography";
import type { VisitDetailData } from "@/components/shared/visits/visit-detail";
import { View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import { ReviewCard } from "@/components/shared/review-card/review-card";
import { formatClientNameHide } from "@/lib/helpers/string";
import { RateVisitImageScroll } from "./scroll";
import { useState } from "react";

export function RateVisitImageCarousel({
  visitData,
  open,
  onOpenChange,
}: {
  visitData: VisitDetailData;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const count = visitData.reviewImageUrls.length;
  const [currentIndex, setCurrentIndex] = useState(0);
  return (
    <BottomDrawerModalAnimated
      open={open}
      onOpenChange={onOpenChange}
      className="web:p-0"
      title={
        <View className="flex flex-row items-center justify-between gap-2 px-6 md:pt-6">
          <IconButton
            variant="secondary"
            color="foreground"
            iconName="arrowLeft"
            rounded="full"
            className="p-2"
            size="lg"
            onClick={() => onOpenChange(false)}
          />
          <Typography variant="body-lg">
            {currentIndex + 1}/{count}
          </Typography>
        </View>
      }
    >
      <RateVisitImageScroll
        imageUrls={visitData.reviewImageUrls}
        onScrollIndexChange={setCurrentIndex}
      />
      <ReviewCard
        clientName={formatClientNameHide(visitData.clientName)}
        rating={visitData.rating}
        date={visitData.serviceDate}
        description={visitData.ratingComment}
      />
    </BottomDrawerModalAnimated>
  );
}
